import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

import { vMaska } from "maska"
import i18n from "./i18n"

import { BootstrapVueNext } from 'bootstrap-vue-next';
import Toast from "vue-toastification";

import "vue-toastification/dist/index.css";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
// JS Bootstrapa dla menu z data-bs-toggle="dropdown" (status, akcje pod kropkami).
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import "@/assets/scss/app.scss";
import "@vueform/multiselect/themes/default.css"

import pinia from '@/state/pinia'

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import '@fortawesome/fontawesome-free/css/all.css';

import { useLocaleStore } from '@/state/pinia/locale'

import { PLUGIN_EXTENSIONS_KEY } from '@/composables/usePluginExtensions'
import buildPluginExtensionsRegistry from '@/plugin-extensions'

const toastOptions = {
  position: "bottom-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
}

const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(BootstrapVueNext)
  .use(vClickOutside)
  .use(i18n)
  .use(Toast, toastOptions)
  .use(registerScrollSpy)
  .directive("maska", vMaska)

const pluginRegistry = buildPluginExtensionsRegistry()
app.provide(PLUGIN_EXTENSIONS_KEY, pluginRegistry)

// Register plugin-contributed routes against the active router instance so
// the admin sees them without core routes.js knowing about specific plugins.
// `meta.requiresPlugin` lets the same guard the side-nav uses keep these
// routes hidden when the plugin is inactive for the current shop.
for (const page of pluginRegistry.pages) {
  router.addRoute({
    path: page.path,
    name: page.name,
    meta: { title: page.title || 'Plugin', authRequired: true, requiresPlugin: page.pluginId },
    component: page.loader,
  })
}

app.mount('#app')

useLocaleStore().init();

import { useAuthStore } from '@/state/pinia';

const authStore = useAuthStore();
authStore.checkSession();